exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-stepper[data-v-6dacd5de]{border:0!important;-webkit-box-shadow:none!important;box-shadow:none!important}.v-stepper[data-v-6dacd5de],.v-stepper__content[data-v-6dacd5de]{padding:0!important}", ""]);

// exports
